'use client';

import { defaultLocale } from '@/lib/i18n/config';
import { useEffect } from 'react';

/**
 * Root not-found fallback (outside [lang], so no locale context).
 *
 * Must NOT call redirect() during render: Next serializes this component as
 * the not-found fallback for every segment without its own not-found.tsx
 * (e.g. the (checkout) group), and a render-time NEXT_REDIRECT is embedded in
 * the RSC payload as an error row. Client error boundaries then catch it as a
 * masked server render error on soft navigation (BEC-24396). As a client
 * component it serializes as an inert module reference, and the redirect only
 * runs if the 404 fallback is actually shown.
 */
export default function RootNotFound() {
  useEffect(() => {
    window.location.replace(`/${defaultLocale}`);
  }, []);

  return null;
}
